import { cloneBranchSchema } from "components/Common/validation"
import TextError from "components/Shared/TextError"
import { Field, Form, Formik } from "formik"
import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Button, Col, Label, ModalBody, ModalHeader, Row } from "reactstrap"
import { cloneBranch } from "store/actions/branchsActions"
import { showAlert } from "store/reducers/alertReducer"

const CloneBranch = ({ toggleCloneModal, t, cloneBranchId, isLoading }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleCloneBranch = (values, { resetForm }) => {
    const { branchId } = values

    const payload = {
      id: cloneBranchId,
      branchId,
    }

    dispatch(cloneBranch(payload))
      .then(action => {
        const { statusCode, status, msg, data } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          const { _id } = data
          navigate(`/branches/edit?id=${_id}`)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div>
      <ModalHeader toggle={toggleCloneModal}>{t("Clone Branch")}</ModalHeader>
      <ModalBody className="pt-0">
        <Formik
          initialValues={{ branchId: "" }}
          validationSchema={cloneBranchSchema}
          onSubmit={handleCloneBranch}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <Row>
                <Col md={12}>
                  <div className="form_field">
                    <Label htmlFor="branchId" className="col col-form-label">
                      <span className="text-danger">*</span>{" "}
                      {t("Branch Reference")}
                    </Label>
                    <Field
                      name="branchId"
                      type="text"
                      id="branchId"
                      placeholder={t("Branch Reference")}
                      className={`form-control ${
                        touched.branchId && errors.branchId ? "is-invalid" : ""
                      }`}
                    />
                    <TextError name="branchId" />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      color="secondary"
                      className="mx-3"
                      onClick={toggleCloneModal}
                    >
                      {t("Close")}
                    </Button>
                    <Button color="success" type="submit" disabled={isLoading}>
                      {t("Save")}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </div>
  )
}

export default CloneBranch
